import { render, staticRenderFns } from "./RsvpSummaryBlock.vue?vue&type=template&id=a357b78c"
import script from "./RsvpSummaryBlock.vue?vue&type=script&lang=js"
export * from "./RsvpSummaryBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports